<!-- =========================================================================================
	File Name: App.vue
	Description: Main vue file - APP
	----------------------------------------------------------------------------------------
	Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
	Author: Pixinvent
	Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="app" :class="vueAppClasses">
    <router-view @setAppClasses="setAppClasses" />
  </div>
</template>

<script>
import themeConfig from "@/../themeConfig.js";

export default {
  data() {
    return {
      vueAppClasses: [],
    };
  },
  watch: {
    "$store.state.theme"(val) {
      this.toggleClassInBody(val);
    },
    "$vs.rtl"(val) {
      document.documentElement.setAttribute("dir", val ? "rtl" : "ltr");
    },
  },
  methods: {
    toggleClassInBody(className) {
      if (className == "dark") {
        if (document.body.className.match("theme-semi-dark"))
          document.body.classList.remove("theme-semi-dark");
        document.body.classList.add("theme-dark");
        document.body.style.backgroundColor = "#121212";
      } else if (className == "semi-dark") {
        if (document.body.className.match("theme-dark"))
          document.body.classList.remove("theme-dark");
        document.body.classList.add("theme-semi-dark");
      } else {
        if (document.body.className.match("theme-dark"))
          document.body.classList.remove("theme-dark");
        if (document.body.className.match("theme-semi-dark"))
          document.body.classList.remove("theme-semi-dark");
        document.body.style.backgroundColor = "#FAF6F1";
      }
    },
    setAppClasses(classesStr) {
      this.vueAppClasses.push(classesStr);
    },
    handleWindowResize() {
      this.$store.commit("UPDATE_WINDOW_WIDTH", window.innerWidth);

      // Set --vh property
      document.documentElement.style.setProperty(
        "--vh",
        `${window.innerHeight * 0.01}px`
      );
    },
    handleScroll() {
      this.$store.commit("UPDATE_WINDOW_SCROLL_Y", window.scrollY);
    },
  },
  mounted() {
    this.toggleClassInBody(this.$store.state.theme);
    this.$store.commit("UPDATE_WINDOW_WIDTH", window.innerWidth);

    let vh = window.innerHeight * 0.01;
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty("--vh", `${vh}px`);
  },
  async created() {
    let dir = this.$vs.rtl ? "rtl" : "ltr";
    document.documentElement.setAttribute("dir", dir);

    window.addEventListener("resize", this.handleWindowResize);
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("resize", this.handleWindowResize);
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style lang="scss">
:root {
  --pok-bg: #faf6f1;
  --pok-card: #ffffff;
  --pok-card-light: #f5f0ea;
  --pok-surface: #f5f0ea;
  --pok-text: #2d2016;
  --pok-text-secondary: #5a4a3a;
  --pok-text-muted: #a89888;
  --pok-border: #e8dfd4;
  --pok-input-bg: #f5f0ea;
  --pok-btn-secondary-bg: #f5f0ea;
  --pok-btn-secondary-text: #2d2016;
}

span.text-grey,
p.text-grey,
div.text-grey,
.text-grey {
  color: var(--pok-text-secondary) !important;
}

.theme-dark {
  --pok-bg: #121212;
  --pok-card: #1e1e1e;
  --pok-card-light: #2a2a2a;
  --pok-surface: #181818;
  --pok-text: #f5f5f5;
  --pok-text-secondary: #999;
  --pok-text-muted: #666;
  --pok-border: #333;
  --pok-input-bg: #1e1e1e;
  --pok-btn-secondary-bg: #1e1e1e;
  --pok-btn-secondary-text: #f5f5f5;
}
</style>
